import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/tom/hacking/energysage/es-poc-auth0-fe/nuxt-app/layouts/default.vue").then(m => m.default || m))
}